module.exports = "footer {\n  padding-bottom: 20px; }\n"